import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TrustpilotService } from 'src/app/services/trustpilot/trustpilot.service';

@Component({
  selector: 'app-trustbox',
  templateUrl: './trustbox.component.html',
  styleUrl: './trustbox.component.scss'
})
export class TrustboxComponent implements AfterViewInit {
  /** Trustpilot's own theme switch: 'dark' renders light text */
  @Input() theme: 'light' | 'dark' = 'light';

  @ViewChild('trustbox') private trustbox?: ElementRef<HTMLElement>;

  constructor(private trustpilotService: TrustpilotService) {}

  ngAfterViewInit(): void {
    this.trustpilotService.render(this.trustbox?.nativeElement);
  }
}
